 const list = [
  {
    name: "数字工厂",
    cover: require("@/assets/images/product/digitalized_factory_bg.png"),
    desc:
      "建立用户和合作伙伴共建智能制造系统的生态环境，以企业价值增值为核心，打造企业智慧研发、智慧管理、智能生产、智能服务和智能决策系列解决方案。",
    sub: [
      {
        name: "企业生产智能化解决方案",
        sub: [
          {
            name: "企业进销存管理系统（PSI）",
            icon: "iconjinxiaocun",
            link: "/product/newManagement",
          },
          {
            name: "标准仓储管理系统（WMS）",
            icon: "iconcangchuguanli",
            link: "/product/newManagement",
          },
          {
            name: "制造执行管理系统（MES）",
            icon: "iconzhizaozhihang",
            link: "/product/newManagement",
          },
          {
            name: "企业供应链管理系统（SCM）",
            icon: "icongongyinglian",
            link: "/product/newManagement",
          },
        ],
      },
      {
        name: "纺织智能制造解决方案",
        sub: [
          {
            name: "生产管理中央控制系统（CCS）",
            icon: "iconshengchanguanli",
            link: "/product/spinning",
          },
          {
            name: "车间管理生产监控管理平台（SFTS）",
            icon: "iconshengchanjiankong",
            link: "/product/spinning",
          },
          {
            name: "企业信息门户（EIP）",
            icon: "iconqiyemenhu",
            link: "/product/spinning",
          },
          {
            name: "质量检测QI验布管理系统（Q1）",
            icon: "iconzhiliangjiance",
            link: "/product/spinning",
          },
        ],
      },
      {
        name: "能源管理系统解决方案",
        sub: [
          {
            name: "陕鼓能源数据管理平台",
            icon: "iconnengyuanguanli",
            link: "/product/resourceManagement",
          },
          {
            name: "智慧燃气管理系统",
            icon: "iconranqi",
            link: "/product/fuelgas",
          }
        ],
      },
    ],
  },
  {
    name: "互联网教育",
    cover: require("@/assets/images/product/network_edu_bg.png"),
    desc:
      "针对在线教育行业的应用场景，海量数据、交互形式多样的特点推出了不同垂直行业的一站式解决方案。",
    sub: [
      {
        name: "互联网+教育解决方案",
        sub: [
          {
            name: "实训邦云课堂",
            icon: "iconyunketang",
            link: "/product/educloud",
          },
          {
            name: "企业大学",
            icon: "icondaxuemingcheng",
            link: "",
          },
        ],
      },
    ],
  },
  {
    name: "医疗大健康",
    cover: require("@/assets/images/product/health_bg.png"),
    desc:
      '基于"医、养、健、管"的产业模式，面向健康管理全流程，精准定位医疗健康服务场景的系列解决方案。',
    sub: [
      {
        name: "智慧医疗/养老解决方案",
        sub: [
          {
            name: "云上中医馆综合服务平台",
            icon: "iconjingyun",
            link: "",
          },
          {
            name: "智慧养老院管理系统",
            icon: "iconyanglaoyuan",
            link: "",
          },{
            name: "鲸云诊所",
            icon: "iconjingyun",
            link: "",
          }
        ],
      },
    ],
  },
]
export default list



// WEBPACK FOOTER //
// ./src/components/page-header/index.js